/* eslint-disable no-shadow */
import Vue from 'vue';
import feathersClient from '../../feathers-client';

const defaultModelJobsPagination = {
	total: 100,
	$skip: 0,
	$limit: 4,
};

const defaultModelJobsFilter = {
	$skip: defaultModelJobsPagination.$skip,
	$limit: defaultModelJobsPagination.$limit,
};

const defaultEligibleCandidatesPagination = {
	total: 100,
	$skip: 0,
	$limit: 10,
};

const defaultEligibleCandidatesFilter = {
	$skip: defaultEligibleCandidatesPagination.$skip,
	$limit: defaultEligibleCandidatesPagination.$limit,
};

export default {
	namespaced: true,
	state: {
		eligibleCandidates: [],
		defaultEligibleCandidatesFilter: defaultEligibleCandidatesFilter,
		eligibleCandidatesFilter: defaultEligibleCandidatesFilter,
		eligibleCandidatesPagination: defaultEligibleCandidatesPagination,
		modelJobs: [],
		modelJobsFilter: defaultModelJobsFilter,
		modelJobsPagination: defaultModelJobsPagination,
		name: null,
		modelJobName: null,
		careLocationId: null,
		careSpecialityTypeId: null,
		jobTitleTypeId: null,
		lowerBand: null,
		upperBand: null,
		careLocation: null,
		careSpeciality: null,
		role: null,
		band: null,
		skills: [],
		primaryValidationData: null,
		jobTemplates: [],
		selectedTemplate: null,
		fullSkills: [],
		jobTitleTypes: [],
		bandTypes: [],
		skillResults: [],
		looseSkills: [],
		loadingTemplates: false,
		selectedModelJobId: null,
		selectedModelJobSkills: [],
		modelJob: {},
	},
	getters: {
		eligibleCandidatesPage: (state) => {
			const { $limit, $skip } = state.eligibleCandidatesPagination;
			return $skip / $limit + 1;
		},
		modelJobsPage: (state) => {
			const { $limit, $skip } = state.modelJobsPagination;
			return $skip / $limit + 1;
		},
		getSummaryData: (state) => {
			const {
				modelJobName, careLocation, careSpeciality, role, band,
			} = state;
			return {
				modelJobName,
				careLocation,
				careSpeciality,
				role,
				band,
			};
		},
		getEditSummaryData: (state) => {
			const {
				modelJobName, careLocation, careSpeciality, role, band,
			} = state;
			return {
				modelJobName,
				careLocation,
				careSpeciality,
				role,
				band,
			};
		},
		getPrimaryValidationData: (state) => state.primaryValidationData,
	},
	mutations: {
		SET_ELIGIBLE_CANDIDATES: (state, eligibleCandidates) => { state.eligibleCandidates = eligibleCandidates; },
		SET_ELIGIBLE_CANDIDATES_PAGINATION: (state, data) => { state.eligibleCandidatesPagination = { ...state.eligibleCandidatesPagination, ...data }; },
		SET_ELIGIBLE_CANDIDATES_FILTER: (state, filter) => { state.eligibleCandidatesFilter = filter; },
		SET_DEFAULT_ELIGIBLE_CANDIDATES_FILTER: (state, filter) => { state.eligibleCandidatesFilter = { ...filter, ...defaultEligibleCandidatesFilter }; },
		SET_MODEL_JOBS: (state, modelJobs) => { state.modelJobs = modelJobs; },
		SET_MODEL_JOBS_PAGINATION: (state, data) => { state.modelJobsPagination = { ...state.modelJobsPagination, ...data }; },
		SET_MODEL_JOBS_FILTER: (state, filter) => { state.modelJobsFilter = { ...state.modelJobsFilter, ...filter }; },
		SET_DEFAULT_MODEL_JOBS_FILTER: (state, filter) => { state.modelJobsFilter = { ...filter, ...defaultModelJobsFilter }; },
		SET_MODEL_JOB_POSTING_DATA: (state, payload) => {
			state.name = payload.name;
			state.modelJobName = payload.modelJobName;
			state.careLocation = payload.careLocation;
			state.careLocationId = payload.careLocationId;
			state.careSpeciality = payload.careSpeciality;
			state.careSpecialityTypeId = payload.careSpecialityTypeId;
			state.role = payload.role;
			state.jobTitleTypeId = payload.jobTitleTypeId;
			state.band = payload.band;
			state.lowerBand = payload.lowerBand;
			state.upperBand = payload.upperBand;
		},
		SET_JOB_SKILLS_FILTER_DATA: (state, payload) => {
			state.careLocation = payload.careLocation;
			state.careSpeciality = payload.careSpeciality;
			state.role = payload.role;
			state.band = payload.band;
		},
		SET_PRIMARY_VALIDATION_DATA: (state, payload) => {
			state.primaryValidationData = payload;
		},
		SET_TEMPLATE_MAPPINGS: (state, payload) => {
			state.jobTemplates = payload;
		},
		SET_SELECTED_TEMPLATE: (state, payload) => {
			state.selectedTemplate = payload;
		},
		SET_SELECTED_MODEL_JOBID: (state, payload) => {
			state.selectedModelJobId = payload;
		},
		SET_BAND_TYPES: (state, payload) => {
			state.bandTypes = payload;
		},
		SET_JOB_TITLE_TYPES: (state, payload) => {
			state.jobTitleTypes = payload;
		},
		SET_MODEL_JOB_NAME: (state, payload) => {
			state.name = payload;
			state.modelJobName = payload;
		},
		SET_SELECTED_MODEL_JOB_SKILLS: (state, payload) => {
			state.selectedModelJobSkills = payload;
		},
		SET_SKILL_RESULTS: (state, payload) => {
			state.skillResults = payload;
		},
		ADD_TO_LOOSE_SKILLS: (state, payload) => {
			state.looseSkills.push(payload);
		},
		REMOVE_FROM_LOOSE_SKILLS: (state, index) => {
			state.looseSkills.splice(index, 1);
		},
		REFRESH_TEMPLATE_SKILLS: (state) => {
			state.selectedTemplate?.jobTemplateSkills.splice();
		},
		SET_LOADING_TEMPLATES: (state, payload) => {
			state.loadingTemplates = payload;
		},
		CLEAR_STORE: (state) => {
			state.modelJobName = '';
			state.name = '';
			state.careLocation = null;
			state.careLocationId = null;
			state.careSpeciality = null;
			state.careSpecialityTypeId = null;
			state.role = null;
			state.jobTitleTypeId = null;
			state.band = null;
			state.lowerBand = null;
			state.upperBand = null;
			state.skills = [];
			state.primaryValidationData = null;
			state.jobTemplates = [];
			state.selectedTemplate = null;
			state.fullSkills = [];
			state.jobTitleTypes = [];
			state.bandTypes = [];
			state.skillResults = [];
			state.looseSkills = [];
			state.loadingTemplates = false;
			state.selectedModelJobId = null;
		},
		SET_MODEL_JOB: (state, payload) => {
			state.modelJob = payload;
		},
	},
	actions: {
		setEligibleCandidatesFilter: ({ commit }, filter) => {
			commit('SET_ELIGIBLE_CANDIDATES_FILTER', filter);
		},
		setDefaultEligibleCandidatesFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_ELIGIBLE_CANDIDATES_FILTER', filter);
		},
		setEligibleCandidatesPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.eligibleCandidatesPagination.$limit;
			commit('SET_ELIGIBLE_CANDIDATES_PAGINATION', { $skip });
			commit('SET_ELIGIBLE_CANDIDATES_FILTER', { $skip });
		},
		getEligibleCandidates: async ({ rootGetters }, filter) => {
			const results = await feathersClient.service('/api/v3/model-job-staff-match-score').find({
				query: {
					$role: rootGetters.currentUserRole,
					fields: ['users'],
					'user.deleted': true,
					...filter,
				}, // trustAdmin
			});
			// commit('SET_ELIGIBLE_CANDIDATES', results.data);
			// const totalCount = results.total;
			// commit('SET_ELIGIBLE_CANDIDATES_PAGINATION', { total: totalCount });
			return results;
		},
		getSelectedUserById: async (context, id) => {
			const url = '/api/v3/users';
			const results = await feathersClient.service(url).get(id);
			return results;
		},
		setModelJobsFilter: ({ commit }, filter) => {
			commit('SET_MODEL_JOBS_FILTER', filter);
		},
		setDefaultModelJobsFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_MODEL_JOBS_FILTER', filter);
		},
		setModelJobsPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.modelJobsPagination.$limit;
			commit('SET_MODEL_JOBS_PAGINATION', { $skip });
			commit('SET_MODEL_JOBS_FILTER', { $skip });
		},
		loadModelJobs: async ({ commit, rootGetters }, filter) => {
			const url = '/api/v3/model-jobs'; // trust-admin
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, fields: ['careLocation', 'careSpeciality', 'jobTitle', 'weightSettings', 'matchScore'], ...filter } });
			commit('SET_MODEL_JOBS', results.data);
			const totalCount = results.total;
			commit('SET_MODEL_JOBS_PAGINATION', { total: totalCount });
			return results.data;
		},
		getSelectedModelJobById: async (context, id) => {
			const url = '/api/v3/model-jobs';
			const results = await feathersClient.service(url).get(id);
			return results;
		},
		loadJobTemplateMappings: async ({
			commit, state, rootGetters, rootState,
		}) => {
			if (rootState.organizationStore.globalFeaturelist?.includes('Shift skills')) {
				const url = '/api/v2/job-template-mappings';
				const upperBand = state?.upperBand;
				const lowerBand = state?.lowerBand;
				commit('SET_LOADING_TEMPLATES', true);
				commit('SET_TEMPLATE_MAPPINGS', []);
				if (upperBand && lowerBand) {
					const results = await feathersClient.service('api/v3/jobtemplatemappings').find({
						query: {
				  jobTitleTypeId: state?.jobTitleTypeId,
				  careLocationId: state?.careLocationId,
				  lowerBand: { $lte: Number(lowerBand) },
				  upperBand: { $gte: Number(upperBand) },
				  $role: rootGetters.currentUserRole,
				  fields: ['jobTemplatesMapping'],
				  $paginate: false,
						},
			  });
					const templateMappings = results.map((mapping) => (mapping.jobTemplateJobTemplateMappings ? mapping.jobTemplateJobTemplateMappings : []));
					let merged = [];
					templateMappings.map((item) => merged = [...merged, ...item]);
					const flatTemplates = merged.map((item) => {
						const jobTemplate = item.jobTemplate;
						jobTemplate.isDefault = item.isDefault;
						return jobTemplate;
					});
					let duplicatesFiltered = flatTemplates.filter((value, index, self) => index === self.findIndex((item) => item.id === value.id));
					if (duplicatesFiltered.length === 0 && state.selectedModelJobId !== null) {
						const jobUrl = '/api/v3/model-jobs'; // trust-admin
						let jobResult = await feathersClient.service(jobUrl).get(state.selectedModelJobId, { query: { $role: rootGetters.currentUserRole, fields: ['careLocation', 'careSpeciality', 'jobTitle'] } });
						jobResult = jobResult;
						const templateResult = await feathersClient.service('api/v3/jobtemplates').find({
							query: {
					  id: jobResult.jobTemplateId,
					  $role: rootGetters.currentUserRole,
					  fields: ['jobTemplateSkills'],
					  $paginate: false,
							},
				  });
						duplicatesFiltered = templateResult;
					}
					commit('SET_TEMPLATE_MAPPINGS', duplicatesFiltered);
					commit('SET_LOADING_TEMPLATES', false);
				}
			}
		},
		loadBandTypes: async({ commit }) => {
			const results = await feathersClient.service('/api/v3/band-types').find({
				query: {
					$sort: { number: 1 },
					$paginate: false,
				},
			});
			commit('SET_BAND_TYPES', results);
		},
		loadJobTitleTypes: async({ commit }) => {
			const results = await feathersClient.service('/api/v3/job-title-types').find({
				query: {
					$paginate: false,
				},
			});
			commit('SET_JOB_TITLE_TYPES', results);
		},
		loadModelJobSkills: async({ commit, rootGetters }, modelJobId) => {
			const filter = {
				modelJobId: modelJobId,
				fields: [],
			};
			const url = '/api/v3/model-job-skills';// Trust-admin
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, ...filter } });
			commit('SET_SELECTED_MODEL_JOB_SKILLS', results);
			return results;
		},
		searchSkills: async({ commit, rootGetters }, searchString) => {
			const results = await feathersClient.service('/api/v3/skills').find({
				query: {
					$role: rootGetters.currentUserRole,
					$search: searchString,
				},
			});
			commit('SET_SKILL_RESULTS', results.data);
		},
		createModelJobWithSkills: async({ state, rootGetters }) => {
			let url;
			if (state.selectedModelJobId !== null) {
				const deleteSkills = state.selectedTemplate?.jobTemplateSkills?.filter((item) => item.selected === false);
				deleteSkills?.map((a) => {
					const query = {
						modelJobId: state.selectedModelJobId,
						skillId: a.skillId,
					};
					const jobSkillUrl = '/api/v3/model-job-skills'; // trust-admin
					feathersClient.service(jobSkillUrl).remove(null, { query: { $role: rootGetters.currentUserRole, ...query } }).then((results) => {

					}).catch((error) => {
						console.log('Error', error);
					});
			 });
			}
			const modelJobData = {
				name: state.modelJobName,
				careLocationId: state.careLocationId,
				careSpecialityTypeId: state.careSpecialityTypeId,
				jobTitleTypeId: state.jobTitleTypeId,
				lowerBand: state.lowerBand,
				upperBand: state.upperBand,
			};
			if (state.selectedTemplate) {
				modelJobData.jobTemplateId = state.selectedTemplate.id;
			}
			let modelJobPostData = {};
			const templateSkills = state.selectedTemplate?.jobTemplateSkills?.filter((item) => item.selected === true);
			const cleanedTemplateSkills = templateSkills?.map((item) => ({ requirement: item.requirement, learningOpportunity: item.learningOpportunity, skillId: item.skill.id }));
			const totalSkills = cleanedTemplateSkills?.concat(state.looseSkills?.map((item) => ({ requirement: item.requirement, learningOpportunity: item.learningOpportunity, skillId: item.skill.id })));
			const allJobSkills = [];
			let filteredDuplicates = [];
			let results;
			if (state.selectedModelJobId !== null) {
				for (let j = 0; j < totalSkills?.length; j++) {
					const fullSkill = totalSkills[j];
					allJobSkills.push({
						requirement: fullSkill?.requirement,
						learningOpportunity: fullSkill?.learningOpportunity,
						skillId: fullSkill?.skillId,
						modelJobId: state.selectedModelJobId,
					});
				}
				filteredDuplicates = allJobSkills?.filter((value, index, self) => index === self.findIndex((item) => item.skillId === value.skillId && item.jobId === value.jobId));
				modelJobData.id = state?.selectedModelJobId;
				modelJobPostData = { ...modelJobData, skills: filteredDuplicates };
				url = '/api/v3/model-jobs'; // trust-admin
				results = await feathersClient.service(url).patch(modelJobData.id, modelJobPostData, { query: { $role: rootGetters.currentUserRole } });
			} else {
				for (let j = 0; j < totalSkills?.length; j++) {
					const fullSkill = totalSkills[j];
					allJobSkills.push({
						requirement: fullSkill.requirement,
						learningOpportunity: fullSkill.learningOpportunity,
						skillId: fullSkill.skillId,
					});
				}
				filteredDuplicates = allJobSkills?.filter((value, index, self) => index === self.findIndex((item) => item.skillId === value.skillId));
				modelJobPostData = { ...modelJobData, skills: filteredDuplicates };
				url = '/api/v3/model-jobs'; // trust-admin
			    results = await feathersClient.service(url).create(modelJobPostData, { query: { $role: rootGetters.currentUserRole } });
			}
			return results;
		},
		deleteModelJobSkills: async ({ rootGetters }, filter) => {
			const url = '/api/v3/model-job-skills';
			const results = await feathersClient.service(url).remove(null, { query: { $role: rootGetters.currentUserRole, ...filter } });
			return results;
		},
		deleteModelJob: async ({ rootGetters }, id) => {
			const url = '/api/v3/model-jobs';
			const results = await feathersClient.service(url).remove(id, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		getCareLocations: async ({ rootGetters }) => {
			const url = '/api/v3/care-locations';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, $paginate: false } });
			return results;
		},
		getModelJobById: async ({ rootGetters }, id) => {
			const url = '/api/v3/model-jobs';
			const results = await feathersClient.service(url).get(id, { query: { $role: rootGetters.currentUserRole, fields: ['careLocation', 'careSpeciality', 'jobTitle', 'weightSettings', 'matchScore'] } });
			return results;
		},
		loadModelJob: async ({ commit, state, rootGetters }, id) => {
			const url = '/api/v3/model-jobs';
			const results = await feathersClient.service(url).get(id, { query: { $role: rootGetters.currentUserRole, fields: ['careLocation', 'careSpeciality', 'jobTitle'] } });
			commit('SET_MODEL_JOB', results);
			if (results && results !== undefined && results !== null) {
				let {
					name, careLocationId, careLocation, careSpecialityTypeId, careSpeciality, jobTitleTypeId, jobTitle, lowerBand, upperBand,
				} = results;

				let data = {};
				if (state.name !== undefined && state.name !== null && state.name !== '') {
					name = state.name;
				}
				if (state.careLocationId !== undefined && state.careLocationId !== null && state.careLocationId !== '') {
					careLocationId = state.careLocationId;
				}
				if (state.careSpecialityTypeId !== undefined && state.careSpecialityTypeId !== null && state.careSpecialityTypeId !== '') {
					careSpecialityTypeId = state.careSpecialityTypeId;
				}
				if (state.jobTitleTypeId !== undefined && state.jobTitleTypeId !== null && state.jobTitleTypeId !== '') {
					jobTitleTypeId = state.jobTitleTypeId;
				}
				if (state.careLocation !== undefined && state.careLocation !== null && state.careLocation.length > 0) {
					careLocation = state.careLocation[0];
				}
				if (state.careSpeciality !== undefined && state.careSpeciality !== null && state.careSpeciality.length > 0) {
					careSpeciality = state.careSpeciality[0];
				}
				if (state.role !== undefined && state.role !== null && state.role.length > 0) {
					jobTitle = state.role[0];
				}
				if (state.band !== undefined && state.band !== null && state.band.length > 0) {
					const band = state.band;
					data.band = band;
				}
				if (state.lowerBand !== undefined && state.lowerBand !== null && state.lowerBand !== '') {
					lowerBand = state.lowerBand;
				}
				if (state.upperBand !== undefined && state.upperBand !== null && state.upperBand !== '') {
					lowerBand = state.upperBand;
				}
				data = {
					modelJobName: name,
					name: name,
					careLocationId: careLocationId,
					careLocation: [careLocation],
					careSpecialityTypeId: careSpecialityTypeId,
					careSpeciality: [careSpeciality],
					jobTitleTypeId: jobTitleTypeId,
					role: [jobTitle],
					lowerBand: lowerBand,
					upperBand: upperBand,
				};
				commit('SET_MODEL_JOB_POSTING_DATA', data); 
			}
			return results;
		},
	},
};// for trust-admin only
